(() => {
  'use strict';
  if (window.PMUnifiedGallery?.version === 2) return;
  const icon = {
    prev:'<path d="m15 18-6-6 6-6"/>', next:'<path d="m9 18 6-6-6-6"/>',
    close:'<path d="m6 6 12 12M18 6 6 18"/>',
    grid:'<rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/>',
    share:'<path d="M12 16V3m-5 5 5-5 5 5M5 13v7h14v-7"/>',
    download:'<path d="M12 3v12m-5-5 5 5 5-5M4 16v5h16v-5"/>'
  };
  const svg = name => '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'+icon[name]+'</svg>';
  const state = {images:[],index:0,owner:null,opener:null,token:0,session:0,mode:'photo',overflow:'',scrollY:0,cache:new Map(),file:null,fileURL:'',action:null};
  let dialog, image, preview, spinner, count, subtitle, caption, film, grid, stage, photo, previous, next, overview, share, download, feedback, feedbackText, fallback;
  const reduced = () => !!window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  const normalize = index => (index % state.images.length + state.images.length) % state.images.length;
  const safeURL = value => {if(!value||typeof value!=='string')return '';try {const u=new URL(value,location.href);return /^https?:$/.test(u.protocol)?u.href:'';} catch {return '';}};
  const fullURL = item => safeURL(item?.full || item?.display || item?.thumb);
  const thumbURL = item => safeURL(item?.thumb || item?.display || item?.full);
  const imageURL = item => safeURL((innerWidth<=700 && item.mobile ? item.mobile : innerWidth*(devicePixelRatio||1)>1600 ? item.full : item.display) || item.display || item.full || item.thumb);
  const canWarm = () => !navigator.connection?.saveData && !['slow-2g','2g','3g'].includes(navigator.connection?.effectiveType);
  function button(name,label,kind) {return '<button type="button" class="pmg-gallery__'+kind+'" data-pmg-'+name+' aria-label="'+label+'" title="'+label+'">'+svg(name==='overview'?'grid':name)+'<span>'+label+'</span></button>';}
  function create() {
    if(dialog?.isConnected) return;
    dialog=document.createElement('dialog');
    dialog.className='pmg-gallery';
    dialog.setAttribute('aria-label','Bildvisare – Pauls Motor');
    dialog.innerHTML=`<div class="pmg-gallery__app">
      <header class="pmg-gallery__top">
        <div class="pmg-gallery__branding"><strong>PAULS MOTOR <em>GALLERI</em></strong><span data-pmg-title></span></div>
        <div class="pmg-gallery__actions"><span class="pmg-gallery__counter" data-pmg-count aria-live="polite" aria-atomic="true"></span>
          ${button('overview','Bilder','overview')}${button('share','Dela bild','action')}${button('download','Ladda ner','action')}${button('close','Stäng bildvisaren','close')}
        </div>
      </header>
      <div class="pmg-gallery__feedback" data-pmg-feedback hidden><span data-pmg-feedback-text role="status" aria-live="polite"></span><div data-pmg-fallback hidden><input type="url" readonly aria-label="Länk till bilden"><a target="_blank" rel="noopener">Öppna bilden</a></div></div>
      <div class="pmg-gallery__photo" data-pmg-photo>
        <div class="pmg-gallery__stage" data-pmg-stage>
          <button type="button" class="pmg-gallery__arrow pmg-gallery__arrow--prev" data-pmg-prev aria-label="Föregående bild">${svg('prev')}</button>
          <figure class="pmg-gallery__figure"><div class="pmg-gallery__image-shell" data-pmg-image-shell>
            <img class="pmg-gallery__preview" data-pmg-preview alt="" decoding="async" width="1600" height="1200">
            <img class="pmg-gallery__image" data-pmg-image alt="" decoding="async" width="1600" height="1200">
            <span class="pmg-gallery__loading" data-pmg-loading role="status">Laddar bild…</span>
          </div><figcaption class="pmg-gallery__caption" data-pmg-caption></figcaption></figure>
          <button type="button" class="pmg-gallery__arrow pmg-gallery__arrow--next" data-pmg-next aria-label="Nästa bild">${svg('next')}</button>
        </div>
        <div class="pmg-gallery__film" data-pmg-film aria-label="Välj bild"></div>
        <div class="pmg-gallery__hint">Välj en miniatyr, använd piltangenterna eller svep för nästa bild</div>
      </div><div class="pmg-gallery__all" data-pmg-grid hidden></div>
    </div>`;
    document.body.append(dialog);
    const find=name=>dialog.querySelector('[data-pmg-'+name+']');
    image=find('image');preview=find('preview');spinner=find('loading');count=find('count');subtitle=find('title');caption=find('caption');film=find('film');grid=find('grid');stage=find('stage');photo=find('photo');previous=find('prev');next=find('next');overview=find('overview');share=find('share');download=find('download');feedback=find('feedback');feedbackText=find('feedback-text');fallback=find('fallback');
    find('close').addEventListener('click',close);
    previous.addEventListener('click',()=>show(state.index-1));
    next.addEventListener('click',()=>show(state.index+1));
    overview.addEventListener('click',()=>{setMode(state.mode==='grid'?'photo':'grid');if(state.mode==='photo')show(state.index);});
    share.addEventListener('click',shareImage);
    download.addEventListener('click',downloadImage);
    fallback.querySelector('input').addEventListener('focus',event=>event.target.select());
    film.addEventListener('click',event=>{const b=event.target.closest('[data-pmg-film-index]');if(b)show(Number(b.dataset.pmgFilmIndex));});
    grid.addEventListener('click',event=>{const b=event.target.closest('[data-pmg-grid-index]');if(b){setMode('photo');show(Number(b.dataset.pmgGridIndex));overview.focus({preventScroll:true});}});
    dialog.addEventListener('click',event=>{if(event.target===dialog)close();});
    dialog.addEventListener('cancel',event=>{event.preventDefault();close();});
    dialog.addEventListener('close',()=>{if(!dialog.open)cleanup();});
    dialog.addEventListener('keydown',event=>{
      if(event.target.matches('input,textarea,select'))return;
      if(event.key==='ArrowLeft'&&state.mode==='photo'&&state.images.length>1){event.preventDefault();show(state.index-1);}
      if(event.key==='ArrowRight'&&state.mode==='photo'&&state.images.length>1){event.preventDefault();show(state.index+1);}
      if(event.key.toLowerCase()==='g'&&!event.ctrlKey&&!event.altKey&&!event.metaKey){event.preventDefault();setMode(state.mode==='grid'?'photo':'grid');if(state.mode==='photo')show(state.index);}
    });
    let start=null;
    stage.addEventListener('touchstart',event=>{start=event.touches.length===1?{x:event.touches[0].clientX,y:event.touches[0].clientY}:null;},{passive:true});
    stage.addEventListener('touchend',event=>{if(!start||!event.changedTouches.length)return;const dx=event.changedTouches[0].clientX-start.x,dy=event.changedTouches[0].clientY-start.y;start=null;if(Math.abs(dx)>46&&Math.abs(dx)>Math.abs(dy)*1.3&&state.images.length>1)show(state.index+(dx<0?1:-1));},{passive:true});
    stage.addEventListener('touchcancel',()=>{start=null;},{passive:true});
  }
  function load(url) {
    if(!url)return Promise.resolve(false);
    if(state.cache.has(url))return state.cache.get(url);
    const result=new Promise(resolve=>{
      const img=new Image();img.decoding='async';
      img.onload=()=>{if(img.decode)img.decode().then(()=>resolve(true),()=>resolve(true));else resolve(true);};
      img.onerror=()=>resolve(false);img.src=url;
    });
    state.cache.set(url,result);
    if(state.cache.size>4)state.cache.delete(state.cache.keys().next().value);
    return result;
  }
  function warm(index) {
    if(state.images.length<2||!canWarm())return;
    const session=state.session;
    const urls=[state.images[normalize(index-1)],state.images[normalize(index+1)]].map(imageURL);
    const task=()=>{if(dialog.open&&state.session===session)urls.forEach(load);};
    if('requestIdleCallback' in window)requestIdleCallback(task,{timeout:1500});else setTimeout(task,200);
  }
  function updateThumbs() {
    const buttons=[...film.querySelectorAll('[data-pmg-film-index]')];
    buttons.forEach((button,i)=>{button.classList.toggle('is-active',i===state.index);button.setAttribute('aria-pressed',String(i===state.index));});
    const target=buttons[state.index];
    if(target&&film.clientWidth)film.scrollTo({left:Math.max(0,target.offsetLeft-film.offsetLeft-(film.clientWidth-target.clientWidth)/2),behavior:reduced()?'instant':'smooth'});
  }
  function resetAction() {
    state.action?.abort();state.action=null;state.file=null;state.fileURL='';
    if(share){share.disabled=false;download.disabled=false;share.removeAttribute('aria-busy');download.removeAttribute('aria-busy');}
    if(feedback){feedback.hidden=true;fallback.hidden=true;feedbackText.textContent='';}
  }
  function show(index) {
    if(!state.images.length)return;
    resetAction();state.index=normalize(index);
    const item=state.images[state.index],token=++state.token;
    count.textContent=String(state.index+1).padStart(2,'0')+' / '+String(state.images.length).padStart(2,'0');
    caption.textContent=item.caption||'';caption.hidden=!item.caption;
    spinner.textContent='Laddar bild…';spinner.hidden=false;
    preview.src=thumbURL(item);preview.hidden=false;
    image.classList.remove('is-ready');image.removeAttribute('src');image.alt=item.alt||'';
    updateThumbs();
    if(state.owner?.matches('[data-pmvp-root]'))state.owner.dispatchEvent(new CustomEvent('pmg:imagechange',{detail:{index:state.index}}));
    if(state.owner?.matches('.pmpp')&&item.mediaId){
      const thumb=[...state.owner.querySelectorAll('[data-pmpp-thumb]')].find(el=>el.dataset.pmppThumb===item.mediaId);
      if(thumb&&!thumb.classList.contains('is-active'))thumb.click();
    }
    if(state.mode==='grid'){spinner.hidden=true;return;}
    const url=imageURL(item);
    load(url).then(ok=>{
      if(token!==state.token||!dialog.open)return;
      if(ok){image.src=url;image.classList.add('is-ready');spinner.hidden=true;preview.hidden=true;warm(state.index);}
      else spinner.textContent='Bilden kunde inte laddas. Välj en annan bild.';
    });
  }
  function setMode(mode) {
    state.mode=mode;const all=mode==='grid';
    photo.hidden=all;grid.hidden=!all;share.hidden=download.hidden=all;
    overview.setAttribute('aria-pressed',String(all));overview.querySelector('span').textContent=all?'Visa bild':'Bilder';
    overview.setAttribute('aria-label',all?'Visa aktuell bild':'Visa alla bilder');
    if(all){resetAction();if(!grid.childElementCount){
      const fragment=document.createDocumentFragment();
      state.images.forEach((item,i)=>{
        const button=document.createElement('button');button.type='button';button.className='pmg-gallery__tile';button.dataset.pmgGridIndex=String(i);button.setAttribute('aria-label','Visa bild '+(i+1)+' av '+state.images.length);
        const img=document.createElement('img');img.src=thumbURL(item);img.alt=item.alt||'';img.loading='lazy';img.decoding='async';
        const number=document.createElement('span');number.textContent=String(i+1);button.append(img,number);fragment.append(button);
      });grid.append(fragment);
    }grid.scrollTop=0;}else updateThumbs();
  }
  function open(items,index,options={}) {
    if(!Array.isArray(items))return false;
    const requested=items[Math.max(0,Math.min(items.length-1,Number(index)||0))];
    const valid=items.filter(item=>item&&fullURL(item));
    if(!valid.length)return false;
    create();
    if(!dialog.open){state.opener=options.opener||document.activeElement;state.scrollY=scrollY;state.overflow=document.documentElement.style.overflow;}
    resetAction();state.session++;state.images=valid;state.owner=options.owner||null;state.cache.clear();
    subtitle.textContent=options.title||'Pauls Motor';film.replaceChildren();grid.replaceChildren();
    const fragment=document.createDocumentFragment();
    valid.forEach((item,i)=>{
      const button=document.createElement('button');button.type='button';button.className='pmg-gallery__thumb';button.dataset.pmgFilmIndex=String(i);button.setAttribute('aria-label','Visa bild '+(i+1)+' av '+valid.length);
      const img=document.createElement('img');img.src=thumbURL(item);img.alt='';img.loading=i<8?'eager':'lazy';img.decoding='async';button.append(img);fragment.append(button);
    });film.append(fragment);
    previous.hidden=next.hidden=overview.hidden=valid.length<2;
    if(!dialog.open)dialog.showModal();
    document.documentElement.style.overflow='hidden';
    setMode(options.overview?'grid':'photo');show(Math.max(0,valid.indexOf(requested)));
    dialog.querySelector('[data-pmg-close]').focus({preventScroll:true});
    return true;
  }
  function cleanup() {
    if(!state.images.length)return;
    const opener=state.opener,oldY=state.scrollY;
    state.token++;state.session++;resetAction();state.cache.clear();state.images=[];state.owner=null;state.opener=null;
    document.documentElement.style.overflow=state.overflow;
    image.removeAttribute('src');preview.removeAttribute('src');
    if(opener?.isConnected)opener.focus({preventScroll:true});
    if(Math.abs(scrollY-oldY)>8)scrollTo(0,oldY);
  }
  function close() {if(dialog?.open){dialog.close();cleanup();}}
  function tell(text,url='') {
    feedback.hidden=false;feedbackText.textContent=text;fallback.hidden=!url;
    if(url){fallback.querySelector('input').value=url;fallback.querySelector('a').href=url;}
  }
  function filename(item,type) {
    const extension=({'image/jpeg':'jpg','image/png':'png','image/webp':'webp','image/avif':'avif','image/gif':'gif','image/svg+xml':'svg'})[type]||'jpg';
    const base=(item.alt||subtitle.textContent||'Pauls-Motor').normalize('NFKD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-zA-Z0-9_-]+/g,'-').replace(/^-|-$/g,'').slice(0,100)||'Pauls-Motor';
    return base+'-'+String(state.index+1).padStart(2,'0')+'.'+extension;
  }
  async function getFile(item,signal) {
    const url=fullURL(item);
    if(state.file&&state.fileURL===url)return state.file;
    const response=await fetch(url,{mode:'cors',credentials:'omit',signal});
    if(!response.ok)throw Error('image');
    const blob=await response.blob();
    if(!blob.size||!blob.type.startsWith('image/'))throw Error('image');
    const file=new File([blob],filename(item,blob.type),{type:blob.type});
    if(!signal.aborted){state.file=file;state.fileURL=url;}
    return file;
  }
  function actionStart(button) {
    state.action?.abort();const controller=new AbortController();state.action=controller;
    feedback.hidden=true;fallback.hidden=true;
    share.disabled=download.disabled=true;button.setAttribute('aria-busy','true');
    return controller;
  }
  function actionEnd(controller) {
    if(state.action!==controller)return;
    state.action=null;share.disabled=download.disabled=false;share.removeAttribute('aria-busy');download.removeAttribute('aria-busy');
  }
  async function copyImageLink(url) {
    if(navigator.clipboard?.writeText){await navigator.clipboard.writeText(url);return true;}
    return false;
  }
  async function downloadImage() {
    const item=state.images[state.index];if(!item)return;
    const controller=actionStart(download);tell('Förbereder nedladdning…');
    try {
      const file=await getFile(item,controller.signal);if(controller.signal.aborted)return;
      const url=URL.createObjectURL(file),link=document.createElement('a');
      link.href=url;link.download=file.name;link.hidden=true;dialog.append(link);link.click();link.remove();
      setTimeout(()=>URL.revokeObjectURL(url),60000);tell('Nedladdningen har startat.');
    }catch(error){if(!controller.signal.aborted)tell('Bilden kunde inte laddas ner här. Öppna bilden och välj Spara bild.',fullURL(item));}
    finally {actionEnd(controller);}
  }
  async function shareImage() {
    const item=state.images[state.index];if(!item)return;
    const url=fullURL(item),title=item.alt||subtitle.textContent||'Pauls Motor';
    const controller=actionStart(share);
    try {
      if(navigator.share){
        let data={title,url};
        let supportsFiles=false;
        try {supportsFiles=!!navigator.canShare?.({files:[new File(['x'],'bild.jpg',{type:'image/jpeg'})]});}catch{}
        if(supportsFiles){
          if(!state.file)tell('Förbereder bilden…');
          let file;
          try {file=await getFile(item,controller.signal);}catch(error){if(controller.signal.aborted)return;}
          if(controller.signal.aborted)return;
          if(file&&navigator.canShare({files:[file]}))data={title,files:[file]};
          if(navigator.userActivation&&!navigator.userActivation.isActive){tell('Bilden är klar. Tryck på Dela bild igen.');return;}
        }
        await navigator.share(data);
        if(!controller.signal.aborted)tell('Delningsrutan har stängts.');
      }else{
        const copied=await copyImageLink(url);
        if(!controller.signal.aborted)tell(copied?'Bildlänken är kopierad. Klistra in den där du vill dela bilden.':'Kopiera bildlänken för att dela bilden.',copied?'':url);
      }
    }catch(error){
      if(controller.signal.aborted||error.name==='AbortError')return;
      tell('Delning kunde inte öppnas. Kopiera bildlänken eller öppna bilden.',url);
    }finally {actionEnd(controller);}
  }
  function vehicleItems(owner) {
    const thumbs=[...owner.querySelectorAll('[data-pmvp-thumb]')];
    if(thumbs.length)return thumbs.map(el=>{const img=el.querySelector('img');return {display:el.dataset.display||el.dataset.full,mobile:el.dataset.mobile||el.dataset.display,full:el.dataset.full||el.dataset.display,thumb:img?.currentSrc||img?.src,alt:img?.alt||owner.dataset.productTitle,caption:''};});
    const large=[...owner.querySelectorAll('[data-pmvp-long-image]')];
    if(large.length)return large.map(el=>({display:el.dataset.pmvEnlargeSrc,full:el.dataset.pmvEnlargeSrc,mobile:el.dataset.pmgMobile,thumb:el.querySelector('img')?.currentSrc||el.querySelector('img')?.src,alt:el.querySelector('img')?.alt}));
    const img=owner.querySelector('[data-pmvp-main-img]');
    return img?[{full:img.currentSrc||img.src,display:img.currentSrc||img.src,thumb:img.currentSrc||img.src,alt:img.alt}]:[];
  }
  function productImageURL(img) {
    const source=safeURL(img.currentSrc||img.src);if(!source)return '';
    const url=new URL(source);
    if(url.hostname==='cdn.shopify.com'||url.pathname.startsWith('/cdn/shop/')){url.searchParams.delete('width');url.searchParams.delete('height');url.searchParams.delete('crop');}
    return url.href;
  }
  function collect(trigger) {
    const vehicle=trigger.closest('[data-pmvp-root]');
    if(vehicle){const active=vehicle.querySelector('[data-pmvp-thumb].is-active');return {items:vehicleItems(vehicle),index:trigger.hasAttribute('data-pmvp-long-image')?Number(trigger.dataset.index)||0:Number(active?.dataset.index)||0,options:{owner:vehicle,opener:trigger,title:vehicle.dataset.productTitle||'Fordonsbilder',overview:trigger.hasAttribute('data-pmv-open-overview')}};}
    const product=trigger.closest('.pmpp');
    if(product){
      const medias=[...product.querySelectorAll('.pmpp__media-item')].filter(el=>el.querySelector('.pmpp__main-image'));
      const active=trigger.closest('.pmpp__media-item')||product.querySelector('.pmpp__media-item.is-active');
      if(!active?.querySelector('.pmpp__main-image'))return null;
      return {items:medias.map(el=>{const img=el.querySelector('.pmpp__main-image'),thumb=[...product.querySelectorAll('[data-pmpp-thumb]')].find(button=>button.dataset.pmppThumb===el.dataset.mediaId)?.querySelector('img');return {mediaId:el.dataset.mediaId,full:productImageURL(img),display:img.currentSrc||img.src,thumb:thumb?.currentSrc||thumb?.src||img.currentSrc||img.src,alt:img.alt||product.dataset.productTitle};}),index:medias.indexOf(active),options:{owner:product,opener:trigger.matches('img')?product.querySelector('[data-pmpp-zoom]')||trigger:trigger,title:product.dataset.productTitle||'Produktbilder'}};
    }
    const travel=trigger.closest('[data-t2-gallery]');
    if(travel){const buttons=[...travel.querySelectorAll('[data-t2-gallery-card]')];return {items:buttons.map(el=>({full:el.dataset.t2Full,display:el.dataset.pmgDisplay||el.dataset.t2Full,mobile:el.dataset.pmgMobile||el.dataset.pmgDisplay,thumb:el.dataset.pmgThumb||el.querySelector('img')?.currentSrc||el.querySelector('img')?.src,alt:el.dataset.t2Alt||'',caption:el.dataset.t2Caption||''})),index:buttons.indexOf(trigger),options:{opener:trigger,owner:travel,title:travel.dataset.pmgTitle||'Pauls Motor Travel'}};}
    const zontes=trigger.closest('[data-pmzd-gallery]');
    if(zontes){const buttons=[...zontes.querySelectorAll('[data-pmzd-gallery-item]')];return {items:buttons.map(el=>({full:el.dataset.full,display:el.dataset.pmgDisplay||el.dataset.full,mobile:el.dataset.pmgMobile||el.dataset.pmgDisplay,thumb:el.dataset.pmgThumb||el.querySelector('img')?.currentSrc||el.querySelector('img')?.src,alt:el.dataset.alt||'',caption:el.dataset.caption||''})),index:buttons.indexOf(trigger),options:{opener:trigger,owner:zontes,title:zontes.dataset.pmgTitle||'Zontes modellbilder'}};}
    return null;
  }
  const triggerSelector='[data-pmvp-next-image],[data-pmv-open-overview],[data-pmvp-long-image],[data-t2-gallery-card],[data-pmzd-gallery-item],.pmpp__main-image,[data-pmpp-zoom]';
  let productTouch=null;
  document.addEventListener('touchstart',event=>{const owner=event.target.closest?.('.pmpp__media-stage');productTouch=owner&&event.touches.length===1?{owner,x:event.touches[0].clientX,y:event.touches[0].clientY}:null;},{capture:true,passive:true});
  document.addEventListener('touchend',event=>{if(!productTouch||!event.changedTouches.length)return;const dx=event.changedTouches[0].clientX-productTouch.x,dy=event.changedTouches[0].clientY-productTouch.y;if(Math.abs(dx)>=42&&Math.abs(dx)>Math.abs(dy)*1.2)productTouch.owner.dataset.pmgSuppressUntil=String(Date.now()+550);productTouch=null;},{capture:true,passive:true});
  document.addEventListener('touchcancel',()=>{productTouch=null;},{capture:true,passive:true});
  document.addEventListener('click',event=>{
    const trigger=event.target.closest?.(triggerSelector);
    if(!trigger||trigger.closest('.pmg-gallery')||trigger.disabled)return;
    const stage=trigger.closest('.pmpp__media-stage');
    if(Number(trigger.dataset.pmgSuppressUntil||stage?.dataset.pmgSuppressUntil||0)>Date.now()){event.preventDefault();event.stopImmediatePropagation();return;}
    const payload=collect(trigger);if(!payload?.items.length)return;
    if(open(payload.items,payload.index,payload.options)){event.preventDefault();event.stopImmediatePropagation();}
  },true);
  document.addEventListener('click',event=>{
    const button=event.target.closest?.('[data-t2-gallery-more]');if(!button)return;
    const root=button.closest('[data-t2-gallery]');if(!root)return;
    const cards=[...root.querySelectorAll('[data-t2-gallery-card]')],limit=Math.max(1,parseInt(root.dataset.t2GalleryPreview||'12',10)||12),expanded=button.getAttribute('aria-expanded')!=='true';
    cards.forEach((card,i)=>{card.hidden=!expanded&&i>=limit;});button.setAttribute('aria-expanded',String(expanded));
    const text=button.querySelector('[data-t2-gallery-more-text]'),label=expanded?button.dataset.t2LessLabel:button.dataset.t2MoreLabel;
    if(text)text.textContent=expanded?label:label+' ('+cards.length+')';
    if(!expanded&&root.getBoundingClientRect().top<-15)root.scrollIntoView({behavior:reduced()?'instant':'smooth',block:'start'});
  });
  document.addEventListener('shopify:section:unload',event=>{if(dialog?.open&&state.owner&&event.target.contains(state.owner))close();});
  window.PMUnifiedGallery={version:2,open,close};
})();
